import { render, staticRenderFns } from "./LoteItem.vue?vue&type=template&id=0eddd81e&"
import script from "./LoteItem.vue?vue&type=script&lang=js&"
export * from "./LoteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports